import { render, staticRenderFns } from "./DetallesConcurso.vue?vue&type=template&id=2c97ff84&scoped=true&"
import script from "./DetallesConcurso.vue?vue&type=script&lang=js&"
export * from "./DetallesConcurso.vue?vue&type=script&lang=js&"
import style0 from "./DetallesConcurso.vue?vue&type=style&index=0&id=2c97ff84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97ff84",
  null
  
)

export default component.exports